<div class="w-100 d-flex flex-column align-items-center justify-content-start text-center">
  <p class="font-19 text-capitalize fw-bold mb-3">{{ 'widget.widget_title' | translate }}</p>
  <!-- ======= counter ======= -->

  <div class="d-flex align-items-center justify-content-center w-100 gap-2 counter">
    <div class="rounded-3 time-card text-center d-flex" [ngClass]="{ shimmer: liveCounter._diff == 0 }">
      <div class="value">{{ liveCounter._days }}</div>
      <div class="indicator">{{ 'widget.days' | translate }}</div>
    </div>
    <div class="rounded-3 time-card text-center" [ngClass]="{ shimmer: liveCounter._diff == 0 }">
      <div class="value">{{ liveCounter._hours }}</div>
      <div class="indicator">{{ 'widget.hours' | translate }}</div>
    </div>
    <div class="rounded-3 time-card text-center" [ngClass]="{ shimmer: liveCounter._diff == 0 }">
      <div class="value">{{ liveCounter._minutes }}</div>
      <div class="indicator">{{ 'widget.minutes' | translate }}</div>
    </div>
    <div class="rounded-3 time-card text-center" [ngClass]="{ shimmer: liveCounter._diff == 0 }">
      <div class="value">{{ liveCounter._seconds }}</div>
      <div class="indicator">{{ 'widget.seconds' | translate }}</div>
    </div>
  </div>

  <p class="my-3 fs-7 text-center" [ngClass]="{ shimmer: !raisedInfo.usdRaised || raisedInfo.usdRaised <= 0 }">
    <span class="text-uppercase"> {{ 'widget.usdt_raised' | translate }} </span>
    <span class="fw-regular">${{ convertNum(raisedInfo.usdRaised) }}</span>
    <span class="fw-regular text-light"> / ${{ convertNum(raisedInfo.maxAmount) }}</span>
  </p>

  <div class="progress" data-percent="0" [ngClass]="{ shimmer: !raisedInfo.usdRaised || raisedInfo.usdRaised <= 0 }">
    <div class="bar" [style.width]="raisedInfo.raisedPercent"></div>
    <div class="status" [ngClass]="{ shimmer: !raisedInfo.usdRaised || raisedInfo.usdRaised <= 0 }">{{ 'widget.bar_title' | translate }}</div>
  </div>

  <div *ngIf="walletAddress" class="d-flex justify-content-center align-items-center text-center mb-2 font-12 px-3 mt-3" [ngClass]="{ shimmer: !raisedInfo.usdRaised || raisedInfo.usdRaised <= 0 }">
    <span class="text-uppercase">{{ 'widget.your_claimable' | translate: { tokenName } }}</span>
    <span class="text-light"> = {{ convertNum(raisedInfo.userStaked + raisedInfo.userClaimable) }}</span>
    <img src="/assets/images/svg-icons/info-icon.svg" class="img-fluid ms-2 cursor-pointer" (click)="yourPurchasedInfo()" alt="" />
  </div>

  <div *ngIf="walletAddress" class="d-flex justify-content-center align-items-center text-center font-12 px-3 mb-3" [ngClass]="[!raisedInfo.usdRaised || raisedInfo.usdRaised <= 0 ? 'shimmer' : '']">
    <span class="text-uppercase">{{ 'widget.your_stakeable' | translate: { tokenName } }}</span>
    <span class="fw-regular text-light"> = {{ convertNum(raisedInfo.userEthClaimable) }}</span>
    <img src="/assets/images/svg-icons/info-icon.svg" class="img-fluid ms-2 cursor-pointer" (click)="stakeInfo()" alt="" />
  </div>

  <button type="button" class="btn btn-sm btn-secondary mb-4 mt-2 mx-auto" (click)="referAndEarn()" *ngIf="walletAddress && referUrl != ''">{{ 'widget.refer_and_earn' | translate }}</button>
</div>
